import type { SystemUserFormData } from '../types';

export const SYSTEM_USER_FIELD_LABELS: Record<string, string> = {
	name: 'Nome',
	surName: 'Sobrenome',
	phoneNumber: 'Telefone',
	email: 'E-mail',
	status: 'Status',
	planId: 'Pacote',
	acceptedTerms: 'Termos de Uso',
};

export const DEFAULT_SYSTEM_USER_FORM: SystemUserFormData = {
	name: '',
	surName: '',
	phoneNumber: '',
	email: '',
	planId: '',
	status: '',
	acceptedTerms: false,
};
